import { OperationDetails } from "./components/saleOperations/details/OperationDetails";

export const SaleOperationsDetails = () => {
  return (
    <div>
      <OperationDetails />
    </div>
  );
};
